import React from "react";
import { SignalBars as TdSignalBars } from "@td/td-ui-kit";
import styles from "./styles.module.scss";
import { useAutoDialer } from "../../utils";

const bandwidthColors = [
  "#ef4723",
  "#ef4723",
  "#fecc09",
  "#0e9246",
  "#0e9246",
];

const SignalBars = (props) => {
  const { mosScore } = useAutoDialer();

  return (
    <TdSignalBars
      barsClassName={styles.bars}
      barsContainerClassName={styles.barsContainer}
      emptySignalColor="#FFFFFF"
      numberOfBars={Math.round(mosScore)}
      signalColor={bandwidthColors[Math.round(mosScore) - 1]}
      {...props}
    />
  )
};

SignalBars.displayName = "SignalBars";

export default SignalBars;
